/** Router de la SPA — routes explicites (§8.2) + guard global unique (§8.3). */
import { createRouter, createWebHistory } from 'vue-router';
import type { Router } from 'vue-router';
import { routes } from './routes';
import { installGuards } from './guard';

/**
 * À appeler APRÈS `initKeycloak()` : `createWebHistory()` fige l'URL courante, et
 * créé plus tôt il réécrirait le fragment `#state=…&code=…` du retour de login.
 */
export function createAppRouter(): Router {
  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior: () => ({ top: 0 }),
  });

  installGuards(router);
  return router;
}
